(() => {
  'use strict';
  
  const SECTION = document.querySelector('.nextdev--blog-posts');
  const SWIPER = SECTION.querySelector('.swiper');

  const swiperInstance = new Swiper(SWIPER, {
    slidesPerView: 'auto',
    spaceBetween: 12,
    slidesPerGroup: 1,
    
    mousewheel: {
      forceToAxis: true
    },

    pagination: {
      el: '.swiper--blog-posts-pagination'
    },

    navigation: {
      prevEl: '.swiper--blog-posts-button-prev',
      nextEl: '.swiper--blog-posts-button-next'
    },

    breakpoints: {
      750: {
        slidesPerGroup: 3
      }
    }
  });
})();
